export default function AboutSection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="lg:w-[45%]">
            <span className="inline-block text-xs font-medium text-primary-600 uppercase tracking-widest border border-primary-200/60 rounded-full px-3 py-1 mb-5">
              About ACBuySpreadsheet
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">
              Why ACBuySpreadsheet<br />
              <span className="text-foreground-500 font-normal">Outperforms Manual Research</span>
            </h2>
            <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
              Traditional product sourcing is slow, disorganized, and hard to scale. <strong>ACBuySpreadsheet</strong> transforms the process into a streamlined, data-driven workflow — helping ecommerce operators make faster decisions, track supplier performance, and scale their dropshipping business with confidence.
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
              Built by operators who understand the challenges of ecommerce growth, the ACBuySpreadsheet system provides a centralized spreadsheet framework that eliminates guesswork and brings clarity to every sourcing decision.
            </p>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-block mt-6 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors underline underline-offset-4 cursor-pointer whitespace-nowrap"
            >
              Learn More on Main Site
            </a>

            <div className="flex gap-12 mt-10">
              <div>
                <span className="font-heading text-4xl md:text-5xl font-bold text-foreground-900">10K+</span>
                <p className="text-xs text-foreground-500 mt-1">Products Tracked</p>
              </div>
              <div>
                <span className="font-heading text-4xl md:text-5xl font-bold text-foreground-900">50+</span>
                <p className="text-xs text-foreground-500 mt-1">Supplier Sources</p>
              </div>
            </div>
          </div>

          <div className="lg:w-[55%] relative">
            <div className="grid grid-cols-2 gap-3 md:gap-4">
              <div className="relative rounded-lg overflow-hidden aspect-[3/4]">
                <img
                  src="https://readdy.ai/api/search-image?query=Organized%20creative%20workspace%20with%20color%20coded%20spreadsheet%20printouts%20and%20product%20samples%20on%20a%20warm%20wooden%20desk%20with%20morning%20sunlight%2C%20fresh%20coffee%20and%20notebook%2C%20cream%20and%20terracotta%20accents%2C%20editorial%20photography%2C%20no%20text%20no%20logos%2C%20productive%20atmosphere&width=600&height=800&seq=about-img-01-v2&orientation=portrait"
                  alt="ACBuySpreadsheet product sourcing workspace"
                  title="ACBuySpreadsheet organized product research workspace"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="relative rounded-lg overflow-hidden aspect-[3/4] mt-8">
                <img
                  src="https://readdy.ai/api/search-image?query=Curated%20product%20samples%20including%20fabric%20swatches%20leather%20pieces%20and%20color%20palette%20cards%20artfully%20arranged%20on%20a%20clean%20white%20surface%2C%20soft%20overhead%20studio%20lighting%2C%20editorial%20style%2C%20no%20text%20no%20logos%2C%20creative%20sourcing%20concept&width=600&height=800&seq=about-img-02-v2&orientation=portrait"
                  alt="ACBuySpreadsheet fashion product sourcing"
                  title="ACBuySpreadsheet fashion category sourcing samples"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}